<tec-item
    [classes]="['item--outline']"
    [tagImage]="{ icon: 'icon-shield', status: 'simple' }"
    [tagIcon]="tagIcon"
    [title]="'PROCESSES.DETAIL.PROHIBITED_CAMERAS' | translate"
    [clickeable]="false"
/>
